<template>
  <div class="app-container">
    <el-form ref="previewForm" :model="previewSubData" label-position="left" label-width="100px" style="width: 700px; margin-left:50px;">
      <el-form-item label="真实姓名" prop="real_name" style="width: 500px;">
        <el-input v-model="previewSubData.real_name" disabled />
      </el-form-item>
      <el-form-item label="年龄" prop="age" style="width: 500px;">
        <el-input v-model="previewSubData.age" disabled />
      </el-form-item>
      <el-form-item label="手机号码" prop="phone" style="width: 500px;">
        <el-input v-model="previewSubData.phone" disabled />
      </el-form-item>
      <el-form-item label="户籍地" prop="registered_residence" style="width: 500px;">
        <el-input v-model="previewSubData.registered_residence" disabled />
      </el-form-item>
      <el-form-item label="邮箱" prop="email" style="width: 500px;">
        <el-input v-model="previewSubData.email" disabled />
      </el-form-item>
      <el-form-item label="照片" prop="avatar">
        <el-image style="width:150px;height: 200px;" :src="previewSubData.avatar[0].path||'/zanwu.png'" fit="cover"></el-image>
      </el-form-item>
      <el-form-item label="身份证号" prop="id_card" style="width: 500px;">
        <el-input v-model="previewSubData.id_card" disabled />
      </el-form-item>
      <el-form-item label="身份证人像面" prop="id_card_portrait">
        <el-image style="width:150px;height: 200px;" :src="previewSubData.id_card_portrait[0].path||'/zanwu.png'" fit="cover"></el-image>
      </el-form-item>
      <el-form-item label="身份证国徽面" prop="id_card_national_emblem">
        <el-image style="width:150px;height: 200px;" :src="previewSubData.id_card_national_emblem[0].path||'/zanwu.png'" fit="cover"></el-image>
      </el-form-item>
      <el-form-item v-for="(item, index) in previewData" :key="index" :label="item.name" :prop="item.field">
        <!-- JSON -->
        <template v-if="item.formtype == 'json'">
          <el-input v-model="previewSubData[item.field]" type="textarea" :width="item.setting.width" :height="item.setting.height" :placeholder="item.tips" disabled />
        </template>
        <!-- 单行文本 -->
        <template v-if="item.formtype == 'text'">
          <el-input v-model="previewSubData[item.field]" :placeholder="item.tips" disabled />
        </template>
        <!-- 多行文本 -->
        <template v-if="item.formtype == 'textarea'">
          <el-input v-model="previewSubData[item.field]" type="textarea" :width="item.setting.width" :height="item.setting.height" :placeholder="item.tips" disabled />
        </template>
        <!-- 编辑器 -->
        <template v-if="item.formtype == 'editor'">
          <el-col>
            <WangEditor v-model="previewSubData[item.field]" :value.sync="previewSubData[item.field]" disabled />
          </el-col>
        </template>
        <!-- 单选 -->
        <template v-if="item.formtype == 'box' && item.setting.boxtype == 'radio'">
          <el-radio v-for="(option, optionKey) in item.setting.options" :key="optionKey" v-model="previewSubData[item.field]" :label="option.value" disabled>
            {{ option.label }}
          </el-radio>
        </template>
        <!-- 下拉 -->
        <template v-if="item.formtype == 'box' && item.setting.boxtype == 'select'">
          <el-select v-model="previewSubData[item.field]" :placeholder="item.tips" disabled>
            <el-option v-for="(option, optionKey) in item.setting.options" :key="optionKey" :label="option.value" :value="option.value"></el-option>
          </el-select>
        </template>
        <!-- 复选 -->
        <template v-if="item.formtype == 'box' && item.setting.boxtype == 'checkbox'">
          <el-checkbox-group v-model="previewSubData[item.field]" disabled>
            <el-checkbox v-for="(option, optionKey) in item.setting.options" :key="optionKey" v-model="previewSubData[item.field]" :label="option.value">{{ option.label }}</el-checkbox>
          </el-checkbox-group>
        </template>
        <!-- 单图 -->
        <template v-if="item.formtype == 'image'">
          <el-image v-if="previewSubData[item.field].length < 1" :style="'width: '+ item.setting.images_width +'px; height: '+ item.setting.images_height +'px'" :src="'/zanwu.png'" fit="cover"></el-image>
          <el-image v-for="(image, i) in previewSubData[item.field]" :key="i" :style="'width: '+ item.setting.images_width +'px; height: '+ item.setting.images_height +'px'" :src="image == undefined ? '/zanwu.png' : image.path" fit="cover"></el-image>
        </template>
        <!-- 多图 -->
        <template v-if="item.formtype == 'images'">
          <el-image v-if="previewSubData[item.field].length < 1" :style="'width:100px; height: 100px'" :src="'/zanwu.png'" fit="cover"></el-image>
          <el-image v-for="(image, i) in previewSubData[item.field]" :key="i" :style="'width:100px; height: 100px'" :src="image == undefined ? '/zanwu.png' : image.path" fit="cover"></el-image>
        </template>
        <!-- 单文件 -->
        <template v-if="item.formtype == 'file'">
          <el-tag v-if="previewSubData[item.field].length < 1" type="danger">暂无文件</el-tag>
          <a v-for="(file, f) in previewSubData[item.field]" :key="f" :href="file.path">
            <el-tag type="success"> {{ file.original_name }} </el-tag>
          </a>
        </template>
        <!-- 单文件 -->
        <template v-if="item.formtype == 'files'">
          <el-tag v-if="previewSubData[item.field].length < 1" type="danger">暂无文件</el-tag>
          <a v-for="(file, f) in previewSubData[item.field]" :key="f" :href="file.path">
            <el-tag type="success"> {{ file.original_name }} </el-tag> <br>
          </a>
        </template>
        <!-- 数字 -->
        <template v-if="item.formtype == 'number'">
          <el-input-number v-model="previewSubData[item.field]" :min="item.setting.min" :max="item.setting.max" disabled></el-input-number>
        </template>
        <!-- 小数 -->
        <template v-if="item.formtype == 'decimal'">
          <el-input-number v-model="previewSubData[item.field]" :precision="item.setting.decimaldigits" :min="item.setting.min" :max="item.setting.max" disabled></el-input-number>
        </template>
        <!-- 日期（2023-04-13） -->
        <template v-if="item.formtype == 'date'">
          <el-date-picker v-model="previewSubData[item.field]" type="date" :placeholder="item.tips" disabled></el-date-picker>
        </template>
        <!-- 日期（2023-04-13 12:01:01） -->
        <template v-if="item.formtype == 'datetime'">
          <el-date-picker v-model="previewSubData[item.field]" type="datetime" :placeholder="item.tips" disabled></el-date-picker>
        </template>
      </el-form-item>
    </el-form>
    <div slot="footer" class="footer" style="    margin-left: 45px;">
      <el-button @click="back">返回</el-button>
    </div>
  </div>
</template>

<script>
// import api from '@/api/examination/records' // 和数据交互相关写在api 方便复用
import commonList from '@/utils/commonList'
import WangEditor from '@/components/WangEditor'

const api = {}

export default {
  name: 'RecordsDetail',
  components: { WangEditor },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      temp: {},
      // 表单模型字段数据集
      previewData: {},
      // 表单提交绑定值
      previewSubData: {},
      // 表单模型必填集
      previewRules: {},
      reocrd_id: 0,
      form_id: 0
    }
  },
  created() {
    this.reocrd_id = this.$route.query.id
    this.form_id = this.$route.query.form_id
    this.Detail()
  },
  methods: {
    Detail() {
      this.isPreview = true
      this.api.Get(
        {
          record_id: this.reocrd_id,
          form_id: this.form_id
        }
      ).then(response => {
        this.previewData = response.data.field
        this.previewSubData = response.data.records
      })
    },
    back() {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
